
























import { Vue, Component, Prop } from 'nuxt-property-decorator';
import HeaderGuest from './HeaderGuest.vue';
import HeaderOutsider from './HeaderOutsider.vue';
import HeaderLanding from './HeaderLanding.vue';
import HeaderWarRoom from './HeaderWarRoom.vue';
import HeaderMenuMember from '~/components/global/HeaderMenu/HeaderMenuMember.vue';
import BravadoLogo from '~/components/global/BravadoLogo/BravadoLogo.vue';
import UniversalSearch from '~/components/common/UniversalSearch/UniversalSearch.vue';
import Search from '~/components/common/Search/Search.vue';
import { isWarRoomUser } from '~/components/partials/war-room/utils';
import { SKIP_ONBOARDING_NAME } from '~/components/partials/war-room/WarRoomSignUp/skipOnboarding';
import { ONBOARDING_V3_EXPECTATIONS_PAGE } from '~/constants';

@Component<Header>({
  components: {
    BravadoLogo,
    // FIXME [Performance] find a way to load headers asyncronycally
    HeaderLanding,
    UniversalSearch,
    // @ts-ignore
    Search,
  },
})
export default class Header extends Vue {
  @Prop({ default: true }) sticky!: boolean;

  get isJobsPage() {
    return this.$route.path.startsWith('/jobs/');
  }

  get isLandingPage() {
    return this.$route.path === '/';
  }

  get isOutsider() {
    const withSkippedOnboarding = this.$cookies.get(SKIP_ONBOARDING_NAME);
    return this.$auth.loggedIn && !isWarRoomUser(this.$auth.user!) && !withSkippedOnboarding;
  }

  /**
   * We show different header type for logged in war room users on mobile
   */
  get isMobileWarRoomHeader() {
    return this.$device.isMobile && this.$auth.loggedIn && !this.isOutsider;
  }

  get logoLink() {
    if (this.isLandingPage || !this.$auth.loggedIn) return '/';
    if (this.isOutsider) return ONBOARDING_V3_EXPECTATIONS_PAGE;
    return '/war-room/posts/tab/my_feed';
  }

  /**
   * Show different actions/buttons in header
   */
  get headerActionsComponent() {
    if (this.isMobileWarRoomHeader) return HeaderWarRoom;
    if (!this.$auth.loggedIn) {
      return this.isJobsPage ? null : HeaderGuest;
    }
    if (this.isOutsider) return HeaderOutsider;
    return HeaderMenuMember;
  }

  get rootClass() {
    return {
      header: true,
      'header--common': !this.isMobileWarRoomHeader && !this.isLandingPage,
      'header--mobile-war-room': this.isMobileWarRoomHeader,
      'header--content-lobby': this.$route.path === '/content-lobby',
    };
  }
}
